import { defineRegistry } from '@json-render/react';
import type { ChartData } from 'types/common';
import { catalog } from './catalog';
import AudienceOverlap from './components/AudienceOverlap';
import Grid from './components/Grid';
import HorizontalStackedBarChart from './components/HorizontalStackedBarChart';
import InsightCard from './components/InsightCard';
import LineBarChartCard from './components/LineBarChartCard';
import OutputCard from './components/OutputCard';
import QuoteCard from './components/QuoteCard';
import RadioStatCard from './components/RadioStatCard';
import SectionTitle from './components/SectionTitle';

export const { registry } = defineRegistry(catalog, {
  components: {
    Grid: ({ props, children }) => (
      <Grid columns={props.columns} gap={props.gap} layout={props.layout}>
        {children}
      </Grid>
    ),
    HorizontalStackedBarChart: ({ props }) => (
      <HorizontalStackedBarChart
        body={props.body}
        colors={props.colors}
        data={props.data as ChartData[]}
        title={props.title}
      />
    ),
    AudienceOverlap: ({ props }) => (
      <AudienceOverlap
        audienceData={props.audienceData}
        stats={props.stats}
        title={props.title}
      />
    ),
    InsightCard: ({ props }) => (
      <InsightCard
        body={props.body}
        description={props.description}
        title={props.title}
        value={props.value}
      />
    ),
    RadioStatCard: ({ props }) => (
      <RadioStatCard
        index={props.index}
        label={props.label}
        percentage={props.percentage}
      />
    ),
    QuoteCard: ({ props }) => (
      <QuoteCard text={props.text} />
    ),
    OutputCard: ({ props }) => (
      <OutputCard
        intro={props.intro}
        items={props.items}
        title={props.title}
      />
    ),
    LineBarChartCard: ({ props }) => (
      <LineBarChartCard rows={props.rows} title={props.title} />
    ),
    SectionTitle: ({ props }) => <SectionTitle text={props.text} />
  }
});
